var map = {
	"./assets/img/Andrew_Li.jpg": "4172",
	"./assets/img/David_Chen.jpg": "5568",
	"./assets/img/Felipe_Kettle.jpg": "cabd",
	"./assets/img/Johnathan_Kong.png": "a41f",
	"./assets/img/Ryan_Yao.jpg": "0534",
	"./assets/img/Scott_Mackay.jpg": "da2c",
	"./assets/img/Shawn_Huynh.jpg": "1368",
	"./assets/img/Sid_Momin.jpg": "58b9",
	"./assets/img/logo.png": "4ffd",
	"./assets/img/portlands-logo.svg": "fb57",
	"./assets/img/portlands.png": "5b9d",
	"./assets/img/questica-logo.png": "2170",
	"./assets/img/questica.png": "29fb",
	"./assets/img/savanta-logo.svg": "1c21",
	"./assets/img/savanta.png": "8837"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";